import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Dropdown, Form } from 'semantic-ui-react';
import cm from 'helpers/commons';
import * as cmAPI_Action from 'actions/commons';

class Store extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.storeSelect(null, { value: 0 });
  }

  storeSelect = async (e, data) => {
    const { commonFn, onChangFunc } = this.props;
    await commonFn.changeStore({
      type: 'store',
      name: 'value',
      value: data.value === 0 ? null : data.value
    });

    if (onChangFunc) onChangFunc();
  };

  render() {
    const { companyStore, notLabel, style, id } = this.props;
    const defaultOptions = [{ value: '0', text: 'Store' }];
    let store_data = null;

    if (companyStore && companyStore.data && companyStore.data.store) {
      store_data = cm.selectDataForMat(companyStore.data.store, '제휴식당 전체');
    }
    return (
      <Form.Field inline className="com-selectbox" style={style} id={id}>
        {notLabel ? null : <label>제휴식당</label>}
        {store_data ? (
          <Dropdown placeholder="Store" selection defaultValue={0} options={store_data} onChange={this.storeSelect} />
        ) : (
          <Dropdown placeholder="Store" selection disabled defaultValue={0} options={defaultOptions} />
        )}
      </Form.Field>
    );
  }
}

Store = connect(
  (state) => ({
    store: state.commons.store
  }),
  (dispatch) => ({
    commonFn: bindActionCreators(
      {
        changeStore: cmAPI_Action.ReduxDataSet
      },
      dispatch
    )
  })
)(Store);

export default Store;
